/** Picks a different route from last time, so players don't always start on the same line. */
export function shuffleRoute(ids: readonly string[], current: string, random: () => number = Math.random): string {
  const others = ids.filter((id) => id !== current);
  if (others.length === 0) return current;
  return others[Math.floor(random() * others.length)] ?? current;
}
